var module;
// LICENSE_CODE ZON
'use strict'; /*jslint node:true, react:true*/

var is_node = typeof module == 'object' && module.exports;
if (is_node) ;else ;
define(['jquery', '/util/etask.js', '/util/escape.js'], function ($, etask, zescape) {
  var E = {};
  E.redir_verified_email = function (force_login, url) {
    return etask('redir_verified_email', [function () {
      return force_login();
    }, function (user) {
      if (user && (user.verified || !user.emails || user.provider != 'basic' && !user.providers)) {
        location.href = url;
      }
    }]);
  };
  E.resend_verification_email = function (opt) {
    opt = opt || {};
    var link = (opt.url_prefix || '') + '/users/send_email_verification';
    return etask('resend_verification_email', [function () {
      return $.post(link, opt.data);
    }]);
  };
  E.resend_premium_verification = function (opt) {
    opt = opt || {};
    var link = '/users/send_premium_verification?' + zescape.qs({
      email: opt.email,
      resend: true
    });
    return etask('resend_verification_email', [function () {
      return $.post(link, {});
    }]);
  };
  return E;
});